import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';
import { SearchFormReactivePipe } from './search-form-reactive.pipe';
import { MatThreePipe } from './mat-three.pipe';
import { MyFilterPipe } from './search-array.pipe';
import { TruncatePipePipe } from './truncate-pipe.pipe';
import { SplitComasPipe } from './split-comas.pipe';



@NgModule({
  declarations: [SearchPipe, SearchFormReactivePipe, MyFilterPipe, TruncatePipePipe, SplitComasPipe],
  imports: [
    CommonModule
  ],
  exports: [
    SearchPipe,
    SearchFormReactivePipe,
    MyFilterPipe,
    TruncatePipePipe,
    SplitComasPipe
  ]
})
export class PipeModule { }
